import Services from './base-services'

const service = new Services('bookUserCatalog')

export default {
    getBookUserCatalogByUserAndBook(data: any) {
        return service.post(
            `getBookUserCatalogByUserAndBook?userId=${data.userId}&bookId=${data.bookId}`
        )
    },
    getBookUserCatalogOnStateReadingOrNotOpenList(id: any) {
        return service.post(`getBookUserCatalogOnStateReadingOrNotOpenList?userId=${id}`)
    },
    getBookUserCatalogOnStateReadList(id: any) {
        return service.post(`getBookUserCatalogOnStateReadList?userId=${id}`)
    },
    uploadReadingProgress(data: any) {
        return service.post('uploadReadingProgress', data)
    },
}
